import React from 'react'

const Two_D = () => {
    return (
        <div className='container'>
            <h1>Dimensional (2D) arrays in C</h1>
            
            <p> The two-dimensional array can be defined as an array of arrays. The
             2D array is organized as matrices which can be represented as the collection
              of rows and columns. However, 2D arrays are created to implement a 
              relational database lookalike data structure. It provides ease of holding 
              the bulk of data at once which can be passed to any number of functions
               wherever required. <br />
            </p>
            <h3>Declaration of two dimensional Array in C</h3>
            <div className='containers'>
            data_type array_name[rows][columns];  <br />
            Example: <br />
            int twodimen[4][3];  <br />
            int arr[4][3]=&#123;&#123;1,2,3&#125;,&#123;2,3,4&#125;,&#123;3,4,5&#125;,&#123;4,5,6&#125;&#125;  <br />
            Here, 4 is the number of rows, and 3 is the number of columns. <br />
            </div>
            <div className='containers'>
            <code className='library'> #include</code>&lt;stdio.h&gt;  <br/>
            <code className='keywords'>int</code> main()&123;       <br/>
            <code className='keywords'>int</code> i=0,j=0;     <br/>
            <code className='keywords'>int</code> arr[4][3]=&123;&123;1,2,3d&#125;,&123;2,3,4d&#125;,&123;3,4,5d&#125;,&123;4,5,6d&#125;d&#125;125;;     <br/> 
            <code className='comment'>//traversing 2D array </code>    <br/>
            <code className='keywords'>for</code>(i=0;i&lt;4;i++)&123;     <br/>
            <code className='keywords'> for</code>(j=0;j&lt;3;j++)&123;     <br/>
            <code className='comment'>  printf</code>("arr[%d] [%d] = %d \n",i,j,arr[i][j]);     <br/>
            <code className='keywords'>&#125;</code><code className='comment'>//end of j </code>    <br/>
            <code className='keywords'>&#125;</code><code className='comment'>//end of i  </code>   <br/>
            <code className='library'>return</code> 0;   <br/>
d&#125;     <br/>
            </div>
        </div>
    )
}

export default Two_D
